import { client } from "api";

export type DeleteCommentRequest = { commentId: string };
export type DeleteCommentResponse = string;

export const deleteComment = ({ commentId }: DeleteCommentRequest) =>
  client.delete<DeleteCommentResponse>(`/checklist/comment/${commentId}`).then((res) => res.data);
